module.exports = __webpack_public_path__ + "img/home_pic_up_1.34e5865d.png";